export enum WebSocketMessageContextResponse {
  RequestAcknowledged = 'WebsocketMessageResponse_RequestAck',
  RequestNotAcknowledged = 'WebsocketMessageResponse_RequestNack',
  RequestResponse = 'WebsocketMessageResponse_RequestResponse'
}
